import { Table } from 'semantic-ui-react';
import React from 'react';
import TaskRow from './TaskRow';
import { FormattedMessage } from 'react-intl';

const prefix = 'tasksTable';

export default function TasksTable(props) {
  const tasks = props.tasks;
  const isIssueDetail = props.isIssueDetail;
  return (
    <>
      {tasks?.length > 0 && (
        <div>
          <div>
            <div className="sub-section-header">
              <FormattedMessage id={`${prefix}.tableHeader`} defaultMessage="TASK LIST" />
            </div>
          </div>

          <Table celled className="task-list-table">
            <Table.Header>
              <Table.Row>
                <th width="15%" className="task-id">
                  <FormattedMessage id={`${prefix}.taskId`} defaultMessage="Task ID" />
                </th>
                <th width="8%" className="status">
                  <FormattedMessage id={`${prefix}.status`} defaultMessage="Status" />
                </th>
                <th width="13%" className="due-date">
                  <FormattedMessage id={`${prefix}.dueDate`} defaultMessage="Due Date" />
                </th>
                <th width="22%" className="assignee">
                  <FormattedMessage id={`${prefix}.assignee`} defaultMessage="Assignee" />
                </th>
                <th width="22%" className="title">
                  <FormattedMessage id={`${prefix}.title`} defaultMessage="Title" />
                </th>
                {isIssueDetail && (
                  <th width="22%" className="stage-name">
                    <FormattedMessage id={`${prefix}.stage`} defaultMessage="Stage" />
                  </th>
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {tasks?.map((eachTask) => {
                return <TaskRow eachTask={eachTask} isIssueDetail={isIssueDetail} key={eachTask.task_id}></TaskRow>;
              })}
            </Table.Body>
          </Table>
        </div>
      )}
    </>
  );
}
